/**
 * json Utils
 *
 * @since 2019-11-20
 * @author mk.ko
 */

export function isJsonString (str) {
  try {
    var json = JSON.parse(str)
    return (typeof json === 'object')
  } catch (e) {
    return false
  }
}
